export default function ( title ) {
    window.smoothData = window.smoothData || []; 
    window.smoothEvent = window.smoothEvent || function (e) { window.smoothData.push(e); }

    if (typeof window.smoothEvent !== "undefined"){        
        window.smoothEvent(title);
    }
}